import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

import { TwoFactorAuthenticationApi, SendEmailOtpRequest } from "../../services";

/**
 * @author Atish Bagate
 */
export const useEmail2FAOTP = () => {
  return useMutationWithLoading(async (params: { sendEmailOtpRequest: SendEmailOtpRequest, xTENANTID?: string }) => {
    const response = await new TwoFactorAuthenticationApi(getConfigObject()).sendEmailOtp(
        params.sendEmailOtpRequest,
        params.xTENANTID
    );
    return response;
  });
};